import React from 'react';

import { appendQueryParams } from '@/helpers/query-string';
import { redirectUrl } from '@/helpers/redirect-url';

import { useHeaderContext } from '../../../context';

import * as S from './company-link.styles';

export const CompanyLink: React.FC = ({ children }) => {
  const { companyProfileLink } = useHeaderContext();
  const url =
    companyProfileLink && appendQueryParams(companyProfileLink, { sc_o: 'jobs_header_company_logo_name_click' });
  return companyProfileLink ? (
    <S.StyledCompanyLink
      href={companyProfileLink}
      onClick={(e) => redirectUrl(e, url as string)}
      data-testid="company-logo-link"
    >
      {children}
    </S.StyledCompanyLink>
  ) : (
    <>{children}</>
  );
};
